import { searchEntities } from '../../store/selectors/search';

export const selectServiceRequests = (state) =>
  searchEntities(state, 'serviceRequests', [
    'ticketId',
    'reporterName',
    'status',
    'serviceType',
    'itemName',
    'propertyName',
    'ticketNumber',
  ]);
